<clr-icon
  shape="layers"
  [style.color]="isDefaultChannel ? '#aaa' : (channelCode | stringToColor)"
></clr-icon>
